import { formatMoney } from "utils";

export const defaultValues = {
  amount: 0,
  accountName: "",
  details: "",
  phone:"",
  date: new Date(),
  attachment: { loading: false, file: null, url: "" },
  notify: false
};

const MAX_AMOUNT = 10000000;
const validateAmount = (value) => {
  console.log(value);
  if (value === "" || value == 0) {
    return "Amount is required";
  } else if (value >= MAX_AMOUNT) {
    return `Please enter an amount less than ${formatMoney(MAX_AMOUNT)}`;
  }
  return true;
};

const validateNotify = ( value, setValue, accountName, phone) => {
  // console.log(value, setValue, accountName, phone);
  if (!value) return true; 
  if(!accountName){
    // setValue("notify",false);
    return "Select an account to notify"
  }
  if (!phone) {
    // setValue("notify",false);
    return "Account does not have a phone number";
  }
  return true;
};

export const formFields = [
  {
    name: 'amount',
    type: 'amount',
    placeholder: 'Amount',
    rules: {
      required: "Amount is required",
      validate: validateAmount
    }
  },
  {
    name: 'date',
    type: 'date',
    placeholder: 'Date',
    rules: {
      required: "Date is required"
    }
  },
  {
    name:"accountName",
    type:"creatable",
    placeholder:"Account Name",
  },
  {
    name: 'detail',
    type: 'textarea',
    placeholder: 'Details',
    fieldProps: {
      maxLength: 50,
      rows: 2
    }
  },
  {
    name:"attachment",
    type:"file",
    placeholder:"Upload File",
  },
  {
    name:"notify",
    type:"checkbox",
    placeholder:"Notify User by SMS",
    rules:{
      required:false,
      validate: validateNotify
    }
  }
];